<template>
  <Header />
  <main>
    <div class="cont">
      <BackButton/>
      <h1>管理者TOP</h1>
      <button v-on:click="showCompanyMaster">会社マスタ</button>
    </div>
  </main>
  <Footer />
</template>

<script>
import Header from '../Header'
import Footer from '../Footer'

export default {
  name: 'AdminTop',
  components: {
    Header,
    Footer
  },
  methods: {
    showCompanyMaster: function() {
      location.href = '/admin/company_master'
    }
  }
}
</script>
